export default "__VITE_ASSET__DeZ2cN0r__"